import script from "./ShoppingButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShoppingButton.vue?vue&type=script&lang=ts&setup=true"

import "./ShoppingButton.vue?vue&type=style&index=0&id=688b3ef8&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-688b3ef8"]])

export default __exports__